var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-init"},[_c('PortraitPromptPanel'),_c('OfflineWarningPanel'),(_vm.showBrowserWarning)?_c('BrowserWarningPanel',{on:{"close":function($event){_vm.showBrowserWarning = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }